<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-dialog v-model="dialogMap" @close="closeDialogMapa">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogMapa">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $tc('relPlot.self', 1) }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text style="margin-top: 25px;">
                    <div ref="plotagempdfdiv" style="width: 100%; height: 75vh;">
                        <l-map ref="mapPlotagem" :zoom="zoom" :center="currentCenter" @update:center="centerUpdate"
                            @update:zoom="zoomUpdate" @ready="onMapPlotagemResize" :options="mapOptions"
                            v-resize="onMapPlotagemResize" style="border-radius: 10px; margin-top: 5px; z-index: 1">
                            <l-tile-layer :url="url" :attribution="attribution" />

                            <l-marker v-for="(reg, k) in reports" :key="`${reg.id_embarque}-${k}`"
                                :lat-lng="latLng(reg.lat, reg.lng)" :visible="markerNotificacoesVisible"
                                :icon="getIconNotificacao(k)" :zIndexOffset="10">
                                <l-popup>
                                    <span v-html="reg.numero_ordem"></span>
                                    <br />
                                    <span v-html="reg.dt_notificacao_extenso"></span>
                                    <br />
                                    <span>{{ `${$t('relMaintenence.headerPositions.lat')}: ${reg.lat}` }}</span>
                                    <br />
                                    <span>{{ `${$t('relMaintenence.headerPositions.lng')}: ${reg.lng}` }}</span>
                                    <br />
                                    <span>{{ `${$tc('passenger.self', 1)}: ${reg.nome_completo}` }}</span>
                                </l-popup>
                            </l-marker>

                            <l-circle v-if="cercaMapa && cercaMapa.circular == 1" :radius="cercaMapa.raio"
                                :lat-lng="[cercaMapa.lat, cercaMapa.lng]">
                            </l-circle>
                            <l-polygon v-else :lat-lngs="latlngs" color="blue"></l-polygon>

                            <l-control :position="'topright'" class="text-overlay">
                                <v-row>
                                    <v-col cols="12" sm="5" md="5">
                                        <v-checkbox v-model="cercasVisible"
                                            :label="$tc('geofence.self', 1)"></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="5" md="5">
                                        <v-checkbox v-model="markerNotificacoesVisible"
                                            :label="$t('relNotification.relNotification')"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </l-control>

                            <l-control :position="'topright'">
                                <v-btn small fab @click="exportPDF($refs.plotagempdfdiv)">
                                    <v-icon color="black">mdi-file-pdf-box</v-icon></v-btn>
                            </l-control>
                        </l-map>
                    </div>
                </v-card-text>
            </v-card>

        </v-dialog>

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <!-- <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                    v-model="idEmpresaSelected"
                    :items="empresas"
                    item-text="razao_social"
                    item-value="id_empresa"
                    clearable
                    label="Empresa"
                    :rules="[(v) => !!v || 'Selecione uma empresa']"
                    @change="onEmpresaChanged"
                ></v-autocomplete>
            </v-col> -->
                    <!-- <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                    v-model="idClienteSelected"
                    :items="clientesSelect"
                    item-text="nome_cliente"
                    item-value="id_cliente"
                    clearable
                    label="Cliente"
                    @change="onClienteChanged"
                ></v-autocomplete>
            </v-col> -->
                    <v-col cols="12" sm="6" md="2">
                        <v-autocomplete v-model="idLinhaSelected" :items="linhasFiltradasPorUnidade" item-text="cod_linha"
                            item-value="id_linha" clearable multiple :label="$tc('line.self', 1)">
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index <= 2" style="margin-right: 5px;">{{ item.cod_linha }}</span>
                                <v-chip v-if="index === 3" class="grey--text text-caption">
                                    <span>(+{{ idLinhaSelected.length - 3 }} {{ $t('operation.others') }})</span>
                                </v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <!-- adicionar unidade -->
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha 
                            :items="unidadesItens"
                            v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            :max-items="2"
                        />
                    </v-col>
                    <!-- termina unidade -->
                    <v-col cols="12" sm="6" md="2">
                        <v-autocomplete v-model="idVeiculoSelected" :items="veiculosFiltradosPorUnidade" item-text="cod_veiculo"
                            item-value="id_veiculo" clearable multiple :label="$tc('vehicle.self', 1)">
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index <= 2" style="margin-right: 5px;">{{ item.cod_veiculo }}</span>
                                <v-chip v-if="index === 3" class="grey--text text-caption">
                                    <span>(+{{ idVeiculoSelected.length - 3 }} {{ $t('operation.others') }})</span>
                                </v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="idPassageiroSelected" :items="passageirosFiltradosPorUnidade"
                            item-text="nome_completo" item-value="id_pessoa" clearable multiple
                            :label="$tc('passenger.self', 1)">
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index <= 1" style="margin-right: 5px;">{{ item.nome_completo }}</span>
                                <v-chip v-if="index === 2" class="grey--text text-caption">
                                    <span>(+{{ idPassageiroSelected.length - 2 }} {{ $t('operation.others') }})</span>
                                </v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="2" align="center" style="align-self: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="setDefaultFilters" style="margin-left: 10px; margin-bottom: 5px;">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.newConsult') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf"
                            :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-switch v-model="mostrarAutorizados" color="primary" :label="$t('relBoarding.authorized')"
                            :disabled="!this.mostrarRecusados"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-switch v-model="mostrarRecusados" color="primary" :label="$t('dashboard.denied')"
                            :disabled="!this.mostrarAutorizados"></v-switch>
                    </v-col>
                </v-row>
                <!-- <v-row>
            <v-col cols="12" sm="6" md="5">
                <v-autocomplete
                    v-model="idVeiculosSelected"
                    :items="veiculosSelect"
                    item-text="numero_ordem"
                    item-value="id_veiculo"
                    multiple
                    clearable
                    label="Veículo"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="5">
                <v-autocomplete
                    v-model="idCercasSelected"
                    :items="cercas"
                    item-text="endereco"
                    item-value="id_cerca"
                    multiple
                    clearable
                    label="Cerca"
                ></v-autocomplete>
            </v-col>
        </v-row> -->
            </v-form>
        </v-container>

      <merus-data-table
        :headers="headers"
        :items="reportsFiltered"
        :loading="loading"
        sort-by="dt_notificacao"
        dense
        class="elevation-7"
        locale="pt"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-top: 10px;"
        

 cod-tabela="RELEVENTOSHIKVISION" append-actions actions-i18n-key="datetime.date" @update:headers="headers = $event">
        
          <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('relBoarding.title')"
                :token="token"
                :items="reportsFiltered"
                csv-title="relembarques"
                :csv-headers="exportHeadersResolved"
                :pdf-title="$t('relBoarding.title')"
                :pdf-headers="exportHeadersResolved"
                pdf-filename="relembarques"
                hide-search
            />
        </template>

            <template v-slot:item.autorizado_extenso="{ item }">
                <v-icon small class="mr-2" :color="item.autorizado == 1 ? 'green' : item.autorizado == 2 ? 'orange' : 'red'">mdi-circle</v-icon>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="blue" @click="plot(item)"
                    :disabled="item.tem_posicao == 0">mdi-map-marker</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import L from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
    LPolygon,
    LCircle
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import DateUtils from "../utils/dateutils";

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        MultiplaEscolha,
        LMap,
        LTileLayer,
        LMarker,
        LControl,
        LPopup,
        LPolygon,
        LCircle
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        showMapa: false,
        recursos: [],
        veiculosSelect: [],
        cercas: [],
        empresas: [],
        linhas: [],
        idLinhaSelected: [],
        veiculos: [],
        idVeiculoSelected: [],
        reports: [],
        dti: null,
        dtf: null,
        idEmpresaSelected: null,
        idVeiculosSelected: [],
        idCercasSelected: [],
        loading: false,
        timeProps: {
            useSeconds: true,
        },
        formValidado: false,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        apikey: "FOvzDukk0SIaGv8RRFW50DQypjKr9HgD7hsV-S3NXFg",
        zoom: 12,
        currentZoom: 11.5,
        currentCenter: null,
        mapOptions: {
            zoomSnap: 0.5,
        },
        cercasVisible: true,
        markerNotificacoesVisible: true,
        notificacoes: [],
        cercaMapa: null,
        latlngs: [],
        map: null,
        dialogMap: false,
        platform: null,
        clientes: [],
        clientesSelect: [],
        passageiros: [],
        passageirosSelect: [],
        idClienteSelected: null,
        idPassageiroSelected: [],
        unidades: [],
        unidadesSelecionadas: [],
        mostrarAutorizados: true,
        mostrarRecusados: true,
        config: null,
    }),
    watch: {
        '$i18n.locale'() {
            this.initialize();
            this.headers = this.defaultHeaders;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user")).id_usuario;
        this.token = sessionStorage.getItem("api");
        this.headers = this.defaultHeaders;
        this.initialize();
    },
    mounted() {
        const platform = new window.H.service.Platform({
            apikey: this.apikey,
        });
        this.platform = platform;
    },
    computed: {
        center() {
            return this.$store.getters['config/centerDefault'];
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            }
        },
        /** Fallback quando tabelas_front/RELEVENTOSHIKVISION não está configurado no banco. */
        defaultHeaders() {
            return [
                { text: this.$t('datetime.date'), value: 'dt_evento_extenso' },
                { text: this.$t('passengers.personal.registrationCode'), value: 'matricula' },
                { text: this.$tc('passenger.self', 1), value: 'nome_completo' },
                { text: this.$t('passengers.personal.cardNumber'), value: 'numero_cartao' },
                { text: this.$t('passengers.personal.shifts'), value: 'cod_turno' },
                { text: this.$tc('geofence.self', 1), value: 'nome_cerca' },
                { text: this.$tc('line.self', 1), value: 'cod_linha' },
                { text: this.$t('relBoarding.header.group'), value: 'nome_grupo' },
                { text: this.$tc('vehicle.self', 1), value: 'numero_ordem' },
                { text: this.$t('vehicleAuthorization.headers.authorized'), value: 'autorizado_extenso', align: 'center' },
                { text: this.$t('vehicleAuthorization.headers.actions'), value: 'actions', sortable: false },
            ];
        },
        /** Headers efetivos para CSV/PDF (fallback se a tabela ainda não emitiu colunas). */
        exportHeadersResolved() {
            return (this.headers && this.headers.length)
                ? this.headers
                : this.defaultHeaders;
        },
        headersWithProperties() {
            return this.headers.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        unidadesItens() {
            return this.unidades;
        },
        linhasFiltradasPorUnidade() {
            return (this.linhas || []).filter((l) => this.passaFiltroUnidades(l));
        },
        veiculosFiltradosPorUnidade() {
            return (this.veiculos || []).filter((v) => this.passaFiltroUnidades(v));
        },
        passageirosFiltradosPorUnidade() {
            return (this.passageiros || []).filter((p) => this.passaFiltroUnidades(p));
        },
        reportsFiltered() {
            let rep = this.reports;

            // if (this.idClienteSelected) {
            //     rep = rep.filter((r) => r.id_cliente == this.idClienteSelected);
            // }

            if (this.idPassageiroSelected.length > 0) {
                rep = rep.filter((r) => this.idPassageiroSelected.includes(r.id_pessoa));
            }

            if (this.idVeiculoSelected.length > 0) {
                rep = rep.filter((r) => this.idVeiculoSelected.includes(r.id_veiculo));
            }

            if (this.idLinhaSelected.length > 0) {
                rep = rep.filter((r) => this.idLinhaSelected.includes(r.id_linha));
            }

            if (this.mostrarAutorizados && !this.mostrarRecusados) {
                rep = rep.filter((r) => r.autorizado == 1);
            }

            if (!this.mostrarAutorizados && this.mostrarRecusados) {
                rep = rep.filter((r) => r.autorizado != 1);
            }

            rep = rep.filter((r) => this.passaFiltroUnidades(r));

            return rep;
        }
    },
    methods: {

        idsUnidadesNoObjeto(o) {
            if (Array.isArray(o.unidades) && o.unidades.length) {
                return o.unidades.map((id) => Number(id));
            }
            if (o.id_unidade != null && o.id_unidade !== "") {
                return [Number(o.id_unidade)];
            }
            return [];
        },
        passaFiltroUnidades(o) {
            if (this.unidadesSelecionadas.length === 0) {
                return true;
            }
            const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
            return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
        },
        initialize() {
            this.currentCenter = this.center;
            this.getConfig();
            this.populaRecursos();
            this.populaUnidades();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                },
            });
        },
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaVeiculos();
                        this.populaCercas();
                        this.populaClientes();
                        this.populaPassageiros();
                        this.populaLinhas();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user },
                    silent: true,
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaVeiculos();
                        this.populaCercas();
                        this.populaClientes();
                        this.populaPassageiros();
                        this.populaLinhas();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                        if (e.message == "Request failed with status code 401") {
                            this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                            this.autorizacaoDialog = true;
                        }
                    },
                });
            }
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                silent: true,
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                silent: true,
                onSuccess: (response) => {
                    this.linhas = response.data || [];
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaCercas() {
            apiController.request(apiController.endpoints.getallCercasativas, {
                silent: true,
                onSuccess: (response) => {
                    this.cercas = response.data;
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculos, {
                onSuccess: (response) => {
                    this.veiculos = response.data || [];
                    this.populaEmpresas();
                },
            });
        },
        populaClientes() {
            apiController.request(apiController.endpoints.getallClientes, {
                onSuccess: (response) => {
                    this.clientes = response.data;
                },
            });
        },
        populaPassageiros() {
            apiController.request(apiController.endpoints.getallPessoas, {
                data: {},
                onSuccess: (response) => {
                    this.passageiros = response.data || [];
                    this.passageirosSelect = this.passageiros;
                },
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response ? e.response.status : null
                    };
                },
            });
        },
        populaVeiculosSelect() {
            this.veiculosSelect = this.veiculos.filter((v) => v.id_empresa === this.idEmpresaSelected);
        },
        populaReports() {
            this.loading = true;

            let dti = DateUtils.getDateSQLFormatted(this.dti);
            let dtf = DateUtils.getDateSQLFormatted(this.dtf);

            apiController.request(apiController.endpoints.getallEventosdata, {
                params: { dti, dtf },
                silent: true,
                onSuccess: (response) => {
                    this.loading = false;
                    this.reports = (response.data && response.data.dados) || [];
                },
                onError: (e) => {
                    this.loading = false;
                    console.log(e);
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (this.formValidado) {
                this.populaReports();
            }
        },
        setDefaultFilters() {
            let today = new Date();
            this.dti = today.toLocaleString().substring(0, 10) + " 00:00:00";
            this.dtf = today.toLocaleString().substring(0, 10) + " 23:59:59";
            this.idVeiculosSelected = [];
            this.idEmpresaSelected = null;
            this.veiculosSelect = [];
            this.unidadesSelecionadas = [];
        },
        plot(item) {
            this.currentCenter = [item.lat, item.lng];
            this.zoom = 14;
            this.notificacoes = item.alertas;
            this.cercaMapa = item;
            if (item.circular == 0) {
                this.latlngs = this.decode(item.shape);
            }
            this.dialogMap = true;
        },
        closeDialogMapa() {
            this.notificacoes = [];
            this.latlngs = [];
            this.zoom = 12;
            this.currentCenter = [-22.88746, -43.29185];
            this.cercaMapa = null;
            this.dialogMap = false;
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        onMapPlotagemResize() {
            if (this.map) {
                this.map.invalidateSize();
            } else {
                this.$refs.mapPlotagem.mapObject.invalidateSize();
            }
        },
        getIconNotificacao() {
            return L.divIcon({
                className: "my-custom-pin",
                html: `<svg fill="#000000" version="1.1" 
                        width="30" height="30" viewBox="0 0 437.699 437.699">
                    <path fill="red" d="M372.578,63.101c-41.18-32.332-95.775-50.138-153.727-50.138c-57.952,0-112.547,17.806-153.728,50.138
                            C23.127,96.073,0,140.162,0,187.244c0,47.688,24.536,93.246,67.589,126.027l-20.81,97.656c-0.893,4.186,0.629,8.518,3.94,11.227
                            c2.079,1.701,4.645,2.582,7.237,2.582c1.538,0,3.087-0.311,4.548-0.943l144.063-62.539c4.104,0.18,8.223,0.271,12.282,0.271
                            c57.952,0,112.545-17.807,153.727-50.139c41.996-32.973,65.123-77.061,65.123-124.144
                            C437.701,140.162,414.574,96.073,372.578,63.101z M218.852,304.393c-15.709,0-28.49-12.78-28.49-28.489
                            c0-15.71,12.781-28.491,28.49-28.491c15.708,0,28.49,12.781,28.49,28.491C247.342,291.612,234.561,304.393,218.852,304.393z
                            M240.721,215.57c-0.771,11.446-10.367,20.417-21.844,20.417c-0.499,0-1.002-0.016-1.505-0.051
                            c-10.867-0.737-19.624-9.498-20.355-20.376l-6.931-102.056c-0.522-7.686,1.98-15.118,7.049-20.926
                            c5.068-5.806,12.092-9.29,19.779-9.813c0.653-0.044,1.313-0.066,1.962-0.066c15.11,0,27.757,11.813,28.778,26.894
                            C248.202,116.2,240.721,215.57,240.721,215.57z"/>
                    </svg>`,
                iconAnchor: [5, 25]
            });
        },
        latLng(lat, lng) {
            if (lat != null && lng !== null) {
                if (lat.trim() !== "0") {
                    return L.latLng(lat, lng);
                } else {
                    return L.latLng(-22.88746, -43.29185);
                }
            } else {
                return L.latLng(-22.88746, -43.29185);
            }
        },
        async exportPDF(div) {
            this.mensagemProgressoDialog = this.$t('notificationMap.messages.extportingPDF');
            this.progressoDialog = true;
            await domtoimage
                .toPng(div)
                .then(function (dataUrl) {
                    var img = new Image(800, 400);
                    img.src = dataUrl;
                    const doc = new jsPDF({
                        orientation: "l",
                        //unit: "cm",
                        //format: [300, 700],
                        format: "a4",
                    });
                    doc.addImage(img, "JPEG", 5, 5, 285, 195);
                    const date = new Date();
                    const filename =
                        `${this.$tc('relPlot.self', 1)}_` +
                        date.getFullYear() +
                        ("0" + (date.getMonth() + 1)).slice(-2) +
                        ("0" + date.getDate()).slice(-2) +
                        ("0" + date.getHours()).slice(-2) +
                        ("0" + date.getMinutes()).slice(-2) +
                        ("0" + date.getSeconds()).slice(-2) +
                        ".pdf";
                    doc.save(filename);
                })
                .catch(function (error) {
                    console.error("oops, something went wrong!", error);
                });
            this.mensagemProgressoDialog = "";
            this.progressoDialog = false;
        },
        decode(encoded) {
            var points = [];
            var index = 0,
                len = encoded.length;
            var lat = 0,
                lng = 0;
            while (index < len) {
                var b,
                    shift = 0,
                    result = 0;
                do {
                    b = encoded.charAt(index++).charCodeAt(0) - 63; //finds ascii                                                                                    //and substract it by 63
                    result |= (b & 0x1f) << shift;
                    shift += 5;
                } while (b >= 0x20);

                var dlat = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
                lat += dlat;
                shift = 0;
                result = 0;
                do {
                    b = encoded.charAt(index++).charCodeAt(0) - 63;
                    result |= (b & 0x1f) << shift;
                    shift += 5;
                } while (b >= 0x20);
                var dlng = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
                lng += dlng;

                points.push({ lng: lng / 1e5, lat: lat / 1e5 });
            }
            return points;
        },
        // onEmpresaChanged() {
        //     if (this.idEmpresaSelected) {
        //         this.clientesSelect = this.clientes.filter((c) => c.id_empresa == this.idEmpresaSelected);
        //     } else {
        //         this.clientesSelect = this.clientes;
        //     }
        //     this.populaVeiculosSelect();
        // }, 
        // onClienteChanged() {
        //     if (this.idClienteSelected) {
        //         this.passageirosSelect = this.passageiros.filter((p) => p.id_cliente == this.idClienteSelected);
        //     } else {
        //         this.passageirosSelect = this.passageiros;
        //     }
        // },
    }
}
</script>